import { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';
import { FORGOT_PASSWORD_MUTATION } from '../../../graphql/client';

export const useForgotPassword = () => {
  const { t, i18n } = useTranslation();

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [forgotPasswordMutation, { loading }] = useMutation(FORGOT_PASSWORD_MUTATION, {
    context: {
      skipPersistedQueries: true,
    },
    onCompleted: (data: any) => {
      if (data && data.forgotPassword) {
        setMessage(t('resetLinkSent', 'A password reset link has been sent to your email address.'));
        setErrorMessage('');
      } else {
        setErrorMessage(t('forgotPasswordError', 'Failed to send reset link. Please try again.'));
      }
    },
    onError: (error: any) => {
      setErrorMessage(error.message || t('forgotPasswordError', 'Failed to send reset link. Please try again.'));
      setMessage('');
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');
    setMessage('');

    if (!email) {
      setErrorMessage(t('emailRequired', 'Email address is required.'));
      return;
    }

    forgotPasswordMutation({
      variables: { email },
    });
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return {
    t,
    i18n,
    email,
    setEmail,
    message,
    errorMessage,
    loading,
    handleSubmit,
    changeLanguage,
  };
};
